
<div :class="$style.root" ref="root">
  <div :class="$style.designerImage" v-if="noData">
    <img :class="[$style.img, $style.lb]" :src="leftBottomImg" />
    <img :class="[$style.img, $style.rt]" :src="rightTopImg" />
    <img :class="[$style.img, $style.md]" :src="middleImg" />
  </div>
  <div v-if="!inIDE && !noData" :class="$style.graph">
    <u-loading :class="$style.loading" size="large" v-if="loading"></u-loading>
    <graph v-if="visible && !loading && !noData" :ast="currentDataSource?.data?.[0]" :initialZoom="initialZoom"></graph>
  </div>
</div>
